<!--坏件库修改页面-->
<template>
  <el-dialog title="修改处理方式"
             :visible.sync="dialogFormVisible"
             custom-class="mini-dialog"
             center
             :close-on-click-modal="false" :append-to-body="true"
             :modal="true">
    <div>
          <el-col :span="24">
          <el-col :span="24" >
            <span class="demonstration">处理方式：</span>
            <el-select v-model="value" placeholder="请选择" style="width: 300px;">
              <el-option
                v-for="item in brokenpartsType"
                :key="item.value"initData
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="24" v-if="value=='退回供应商'" style="margin-top: 20px">
            <span class="demonstration">&nbsp;&nbsp;供 应 商：</span><el-input v-model="customername" auto-complete="off" style="width: 300px" :required="true" @click.native="changepcustomer" placeholder="请选择"></el-input>
          </el-col>
        </el-col>
      <ExternaldeptChaiDanSel ref="zhuandan" :unitgroup="3" @select="selectpcustomer" :title="'选择供应商'"></ExternaldeptChaiDanSel>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" class="qrbtn" @click="update" :loading="loading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {changeBrokenparks} from '@/api/set/csagreement';
  import ExternaldeptChaiDanSel from '@/components/set/externaldept/ExternaldeptChaiDanSel'

  export default {
    name: 'StorageBadChange',
    data() {
      return {
        msg: '修改坏件库出库方式',
        loading:false,
        tableData:[],
        contralData:{},
        customername:'',
        customerserial:'',
        dialogFormVisible: false,
        value: '',
        brokenpartsType: [
          {value: "损耗", name: "损耗"},
          {value: "入正式库", name: "入正式库"},
          {value: "原片使用", name: "原片使用"},
          {value: "退回供应商", name: "退回供应商"},
        ],
      }
    },
    methods: {
      selectpcustomer(pcustomerserial, pcustomer) {
        this.customerserial = pcustomerserial
        this.customername = pcustomer
      },
      changepcustomer() {
        this.seedcodes = []
        for (let i in this.tableData) {
          if (this.seedcodes.indexOf(this.tableData[i].seedcode) == -1)
            this.seedcodes.push(this.tableData[i].seedcode)
        }
        if (this.seedcodes.length == 0) {
          if (this.seedcode) {
            this.seedcodes.push(this.seedcode)
          }
        }
        this.$refs.zhuandan.initData(this.seedcodes)
        this.$refs.zhuandan.show()
      },
      errorMsg(msg){
        this.$message({
          message: msg,
          type: 'error'
        })
        this.loading=false;
      },
      update() {
        this.loading = true;
        if (!this.value) {
          this.errorMsg('请选择处理方式');
          return
        }
        if (this.value == '退回供应商' && !this.customerserial) {
          this.errorMsg('请选择供应商');
          return;
        }
        if(this.value != '退回供应商') {
          this.customername = '';
          this.customerserial = '';
        }

        var row = {
          handlemode: this.value,
          erpserial: this.contralData.erpserial,
          customername: this.customername,
          customerserial: this.customerserial
        };
        changeBrokenparks(row).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
            this.$emit('bindData', row);
            this.dialogFormVisible = false;
          } else {
            this.errorMsg(response.data.msg);
            this.loading = false;
          }
        })
      },
      initData(item,list) {
        this.dialogFormVisible=true;
        this.loading=false;
        this.tableData=list;
        this.contralData=item;

        this.value = this.contralData.handlemode;
        this.customerserial = item.customerserial;
        this.customername = item.customername;
      },
    },
    components: {
      ExternaldeptChaiDanSel
    },

    mounted() {
    },

  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBadChange.vue